<template>
	<div>
		<div class="dds-stepflows">
			<ul class="stepflow-group clearfix">
				<li>
					<div class="icon">
						<i class="iconfont iconfont-step-sign icon-weibiaoti5"></i>
					</div>
					<div class="title">注册账号</div>
					<div class="num">01</div>
				</li>
				<li >
					<div class="flow">登录账号</div>
				</li>
				<li>
					<div class="icon">
						<i class="iconfont iconfont-step-realname icon-shimingrenzheng"></i>
					</div>
					<div class="title">实名认证</div>
					<div class="num">02</div>
				</li>
				<li >
					<div class="flow">绑定提现账号</div>
				</li>
				<li>
					<div class="icon">
						<i class="iconfont iconfont-step-input icon-tijiao"></i>
					</div>
					<div class="title">提交卡密</div>
					<div class="num">03</div>
				</li>
				<li >
					<div class="flow">等待平台验卡</div>
				</li>
				<li>
					<div class="icon">
						<i class="iconfont iconfont-step-verify icon-yanzheng"></i>
					</div>
					<div class="title">验卡成功</div>
					<div class="num">04</div>
				</li>
				<li >
					<div class="flow">相应资金到账</div>
				</li>
				<li>
					<div class="icon">
						<i class="iconfont iconfont-step-cash icon-tixian1"></i>
					</div>
					<div class="title">账户提现</div>
					<div class="num">05</div>
				</li>
				<li >
					<div class="flow">支付宝或微信</div>
				</li>
				<li>
					<div class="icon">
						<i class="iconfont iconfont-step-completed icon-wancheng"></i>
					</div>
					<div class="title">交易成功</div>
					<div class="num">06</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		name:"flow",
		data(){
			return{

			}
		},
		created(){

		},
		methods:{

		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/flow/index.vue